import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { first } from 'rxjs';
import { environment as env } from '../../../environments/environment';
import { PricingStatusId, PropertyAssociationType } from '../enums/property.enum';

@Injectable({
    providedIn: 'root'
})
export class LgvPropertyService {

    constructor(private http: HttpClient) { }

    addClientProperty(clientId: string, propertyDetails) {
        if (propertyDetails?.propertyAssociationTypeId === PropertyAssociationType.Prospect) {
            propertyDetails = {
                ...propertyDetails,
                pricingStatusId: PricingStatusId.PricingInfoNeededClientandProperty
            };
        }
        const url = `${env.LgvApiBaseUrl}/clients/${clientId}/properties`;
        return this.http.post<any>(url, propertyDetails).pipe(first());
    }

    getPropertyTypes() {
        const url = `${env.LgvApiBaseUrl}/types/property`;
        return this.http.get<any>(url).pipe(first());
    }

    getPropertiesByClientId(clientId: string) {
        const url = `${env.LgvApiBaseUrl}/clients/${clientId}/properties`;
        return this.http.get<any>(url).pipe(first());
    }

    validateProperty(param) {
        const url = `${env.LgvApiBaseUrl}/properties/validation?address=${param.address}&zip=${param.zipCode}&state=${param.state}&city=${param.city}`;
        return this.http.get<any>(url, param).pipe(first());
    }

    searchBatchDataAddress(body) {
        const url = `https://api.batchdata.com/api/v1/address/autocomplete`;
        return this.http.post<any>(url, body).pipe(first());
    }
}
